import "./console.scss";
import ConsoleRouter from "./routes";
import { AuthProvider } from "shared/context/auth";
import { StaticDataProvider } from "context/staticData";
import { EntityContextProvider } from "./context/entity";
import React from "react";
import Favicon from "react-favicon";
import { ADMIN_CONSOLE_FAVICON_URL, FEATURE_CONTROL_WHITELISTED_ROUTES_FOR_MOBILE } from "shared/utils/constants";
import FeatureControlCheck from "../../shared/components/featureControlCheck";
import { CommonFeaturesProvider } from "../../context/commonFeatures";

export default function Console() {
  return (
    <React.Fragment>
      <Favicon url={ADMIN_CONSOLE_FAVICON_URL} />
      <StaticDataProvider>
        <CommonFeaturesProvider>
          <FeatureControlCheck
            isTabletSupported={false}
            isMobileSupported={false}
            whiteListedRoutesForMobile={FEATURE_CONTROL_WHITELISTED_ROUTES_FOR_MOBILE}>
            <AuthProvider>
              <EntityContextProvider>
                <ConsoleRouter />
              </EntityContextProvider>
            </AuthProvider>
          </FeatureControlCheck>
        </CommonFeaturesProvider>
      </StaticDataProvider>
    </React.Fragment>
  );
}
